import { z } from 'zod';
import { InvalidArgumentError } from '@commander-js/extra-typings';

export function validateUUID(value: string) {
  const parsed = z.string().uuid().safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid GUID');
}
